export default class PuzzleGenerator {

    static generate(gameConfig, elementFactory, n = 30) {
        const matchCounts = gameConfig.getValue("generator.matchCounts");
        const poolSize = gameConfig.getValue("generator.poolSize");
        const visibleMatches = gameConfig.getValue("generator.visibleMatches");//possible nrs of matches in initial viewport
        const locations = gameConfig.getValue("locations");
        const firstTarget = gameConfig.getValue("generator.first").target;
        const firstMirrored = gameConfig.getValue("generator.first").mirrored;
        const itemPool = [];
        const itemCount = gameConfig.getValue("items").length;
        for (let i = 0; i < itemCount; i++) itemPool.push(i);

        const puzzles = [];
        for (let i = 0; i < n; i++) {
            //rotate through available locations
            const locationIndex = i % locations.length;
            const location = locations[locationIndex];
            const locationSkin = elementFactory.getLocation(locationIndex);
            locationSkin.gotoAndStop(0);
            const slots = locationSkin.children.filter(child => child.name && child.name.indexOf("slot") == 0);
            // NB: index of slot is not necessarily same as postfix in slot.name (e.g. 'slot64'), 
            //  so we sort them to make sure name and index correspond so we can use indices
            slots.sort((slotA, slotB) => parseInt(slotA.name.substr(4)) - parseInt(slotB.name.substr(4)));
            const slotCount = slots.length;
            //Indices of slots which are in initial viewport:
            const visibleSlots = location.visibleSlots;//.map(postfix => slots.findIndex(slot => slot.name == "slot" + postfix));
            //Determine main puzzle features:
            const match = i == 0 ? firstTarget : pick(itemPool);
            const flipped = i == 0 ? firstMirrored : Math.random() < .5;
            //Use `poolSize` different items in puzzle:
            const pool = ArrayUtil.shuffle(itemPool.slice(0).filter(itemIdx => itemIdx != match)).slice(0, poolSize - 1);
            //Collect indices of lots that have same mirroring as target
            //  NB: when flipped, skewY == 180, and not scaleX == -1! For completeness, we check both.
            const correctlyFlippedSlots = slots.filter(slot => (slot.scaleX < 0 || slot.skewY == 180) == flipped).map(slot => slots.indexOf(slot));
            const correctlyFlippedVisibleSlots = visibleSlots.filter(slotIdx => correctlyFlippedSlots.indexOf(slotIdx) > -1);
            //Determine some more puzzle features:
            const visibleMatchCount = Math.min(pick(visibleMatches), correctlyFlippedVisibleSlots.length);
            const matchCount = pick(matchCounts) - visibleMatchCount;
            //Assign items to slots
            const items = [];
            //  First make sure there are N matches in initial viewport:        
            ArrayUtil.shuffle(correctlyFlippedVisibleSlots);
            for (let i = 0; i < visibleMatchCount; i++) {
                items[correctlyFlippedVisibleSlots[i]] = match;
                const idx = correctlyFlippedSlots.indexOf(correctlyFlippedVisibleSlots[i]);
                correctlyFlippedSlots.splice(idx, 1);
            }
            //  Then assign 'matchCount' matches in other correctly flipped slots (outside initial viewport)    
            ArrayUtil.shuffle(correctlyFlippedSlots);
            for (let i = 0; i < matchCount; i++) {
                items[correctlyFlippedSlots[i]] = match;
            }
            //  Finally, fill all other slots randomly
            for (let j = 0; j < slotCount; j++) {
                if (items[j] == null) {
                    items[j] = pick(pool);
                }
            }

            puzzles.push({
                location: locations.indexOf(location),
                target: match,
                flipped: flipped,
                count: matchCount + visibleMatchCount,
                items: items
            });
        }
        return puzzles;
    }
}

const pick = function(pool) {
    return pool[Math.floor(Math.random() * pool.length)];
}

const ArrayUtil = {};
ArrayUtil.shuffle = function(a) {
    let j, x, i;
    for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }
    return a;
}